/*! @license Firebase v3.7.6
Build: rev-d1c8cec
Terms: https://firebase.google.com/terms/ */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var firebase = require('./app');
require('./auth');
var Storage, XMLHttpRequest;

require('./database');
require('./storage');
var AsyncStorage;

require('./messaging');
exports.default = firebase;
module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./~/firebase/firebase-browser.js
// module id = 78
// module chunks = 2